import React, { useEffect, useState } from 'react';
import Select from 'react-select';

import { addNotification } from '../../../../actions/reduxActions/notification';
import { getAllServices } from '../../../../sources/service';
import { setAuthorizationServiceId, setAuthorizationUsersOrGroups } from '../../../../actions/reduxActions/swimlanes';
import { connect } from 'react-redux';
import { pathOr } from 'ramda';
import { selectStyles } from '../../../../utils/core';

const ServicesDropdown = ({ mapElement, tenantId, authenticationToken, setServiceId, resetUsersOrGroups, onError }) => {
    const [services, updateServices] = useState([]);
    const [isLoading, updateLoader] = useState(true);

    const fetchServices = async () => {

        try {
            const servicesResults = await getAllServices({
                token: authenticationToken,
                tenantId,
            });
            updateServices(servicesResults);
            
        } catch ({ message }) {
            onError({
                type: 'error',
                message,
                isPersistent: true,
            });
        } finally {
            updateLoader(false);
        }
    };

    const onChange = ({ value }) => {
        setServiceId({ groupElement: mapElement, serviceElementId: value });

        // Changing the service should clear the authorized users/groups 
        resetUsersOrGroups(mapElement.id, null, 'user');
        resetUsersOrGroups(mapElement.id, null, 'group');
    };

    useEffect(() => {
        fetchServices();
    }, []);

    const defaultServiceId = pathOr('', ['authorization', 'serviceElementId'], mapElement);
    const serviceOptions = services.map(service => ({ value: service.id, label: service.developerName }));
    const selectedService = services.find(service => service.id === defaultServiceId);

    return (
        <>
            {isLoading ? 'Loading Services' : (           
                <Select
                    inputId="swimlane-services"
                    name="swimlane-services"
                    isMulti={false}
                    styles={selectStyles}
                    options={serviceOptions}
                    onChange={onChange}
                    placeholder="Select a service"
                    value={selectedService ? { value: selectedService.id, label: selectedService.developerName } : null}
                    noOptionsMessage={() => 'No results found'}
                />
            )}
        </>
    );
};

export default connect(
    ({ currentUser }) => ({
        tenantId: currentUser.tenantId,
        authenticationToken: currentUser.authenticationToken,
    }),
    { setServiceId: setAuthorizationServiceId, resetUsersOrGroups: setAuthorizationUsersOrGroups, onError: addNotification },
)(ServicesDropdown);
